export enum SearchEntityType {
	APPLICATION = 'APPLICATION',
	WORKSTATION = 'WORKSTATION',
	MOBILE_DEVICE = 'MOBILE_DEVICE',
	DATA = 'DATA',
	SERVER = 'SERVER',
	NETWORK = 'NETWORK',
	ROUTER = 'ROUTER',
	USER = 'USER',
	ORGANIZATION = 'ORGANIZATION',
}

export interface GlobalResearch {
	query: string;
	items: SearchItem[];
	counts: Partial<Record<SearchEntityType, number>>;
	total: number;
}

export interface SearchItem {
	id: string;
	name: string;
	description: string | null;
	icon: string;
	type: SearchEntityType;
	matchedOn: string;
	ip: string | null;
	os: string | null;
	user: string | null;
	state: string | null;
	serverDataCollectionStatus: string | null;
}

/** Results of one entity type, in display order — derived in GlobalResearchStore. */
export interface GlobalResearchSection {
	type: SearchEntityType;
	items: SearchItem[];
}
